import { useEffect } from "react";
import { Link } from "wouter";

const updatedDate = "May 31, 2026";

export default function Privacy() {
  useEffect(() => {
    document.title = "Privacy Policy | Codevector Cloud";
  }, []);

  return (
    <main className="h-screen overflow-y-auto bg-background text-foreground">
      <div className="mx-auto max-w-3xl px-6 py-10 sm:py-14">
        <Link
          href="/"
          className="mb-8 inline-flex text-sm font-medium text-primary hover:underline"
        >
          Back to Codevector
        </Link>

        <article className="prose prose-invert max-w-none prose-headings:text-foreground prose-p:text-muted-foreground prose-li:text-muted-foreground prose-a:text-primary">
          <p className="text-sm font-medium uppercase tracking-wide text-primary">
            Codevector Cloud
          </p>
          <h1>Privacy Policy</h1>
          <p>
            Last updated: {updatedDate}
          </p>

          <p>
            This Privacy Policy explains how Codevector Cloud handles data for
            its private/internal Threads publishing automation tool.
          </p>

          <h2>Information We Collect</h2>
          <p>
            The app may collect and store only the data needed to draft,
            approve, and publish owner-authorized content:
          </p>
          <ul>
            <li>Threads account ID and account name.</li>
            <li>Access tokens required to publish approved content.</li>
            <li>Submitted content and media prepared for publishing.</li>
            <li>Telegram approval metadata if Telegram approval is enabled.</li>
          </ul>

          <h2>How We Use Information</h2>
          <p>We use this information only to:</p>
          <ul>
            <li>Draft content for review.</li>
            <li>Route content for owner approval.</li>
            <li>Publish content the owner authorizes.</li>
            <li>Maintain basic logs needed for security and troubleshooting.</li>
          </ul>

          <h2>Sharing and Sale of Data</h2>
          <p>
            We do not sell data. We do not share Threads data, submitted
            content, media, access tokens, or approval metadata with third
            parties except as required to operate the authorized publishing
            workflow, comply with law, or protect the security of the app.
          </p>

          <h2>Cookies and Analytics</h2>
          <p>
            The website may use cookies, local storage, or analytics tools to
            remember preferences, understand usage, and improve performance. You
            can control cookies through your browser settings.
          </p>

          <h2>Data Retention</h2>
          <p>
            We keep personal information only as long as reasonably necessary
            for the purposes described in this policy, unless a longer retention
            period is required by law or platform requirements.
          </p>

          <h2>Data Deletion</h2>
          <p>
            You can request deletion of personal data associated with
            Codevector Cloud by emailing{" "}
            <a href="mailto:lockogift@gmail.com">lockogift@gmail.com</a>.
            Please include your Threads username and the subject "Data Deletion
            Request". We will process deletion requests within 30 days.
          </p>

          <h2>Third-Party Services</h2>
          <p>
            Codevector Cloud may link to or integrate with third-party services
            such as Meta, GitHub, LinkedIn, hosting providers, analytics
            providers, or cloud services. Their privacy practices are governed
            by their own policies.
          </p>

          <h2>Security</h2>
          <p>
            We use reasonable technical and organizational measures to protect
            information. However, no internet service can guarantee absolute
            security.
          </p>

          <h2>Children's Privacy</h2>
          <p>
            Codevector Cloud is not directed to children under 13, and we do not
            knowingly collect personal information from children under 13.
          </p>

          <h2>Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. Updates will be
            posted on this page with a new last updated date.
          </p>

          <h2>Contact</h2>
          <p>
            For questions about this Privacy Policy or your data, contact:
            <br />
            <a href="mailto:lockogift@gmail.com">lockogift@gmail.com</a>
          </p>
        </article>
      </div>
    </main>
  );
}
